import type {
    IntentSignalDomainsEventDto,
    IntentSignalEventDto,
    IntentSignalEventInfoDto } from "../../../types/signals";
import {
    isIntentSignalCompanyEvent,
    isIntentSignalDomainsEvent,
} from "../../../types/signals";

const getIntentSignalDomainsEventsFromDto = (
    intentSignalEventDtos: Readonly<IntentSignalDomainsEventDto>,
): readonly IntentSignalEventInfoDto[] => {
    return intentSignalEventDtos.domains.reduce((domainsEvents, domainEventDto) => {
        return [...domainsEvents, ...domainEventDto.events];
    }, []);
};

export const getIntentSignalEventsFromDto = (
    intentSignalEventDtos: Readonly<IntentSignalEventDto>,
): readonly IntentSignalEventInfoDto[] => {
    if (isIntentSignalCompanyEvent(intentSignalEventDtos)) {
        return intentSignalEventDtos.events;
    }

    if (isIntentSignalDomainsEvent(intentSignalEventDtos)) {
        return getIntentSignalDomainsEventsFromDto(intentSignalEventDtos);
    }

    return [];
};

export const getIntentSignalsEventsFromDto = (
    intentSignalsEventDtos: readonly IntentSignalEventDto[],
): readonly IntentSignalEventInfoDto[] => {
    return intentSignalsEventDtos.reduce(
        (events, signalEventDto) => [...events, ...getIntentSignalEventsFromDto(signalEventDto)],
        [],
    );
};
